const apiUrl = process.env.REACT_APP_API_URL;
export const PostRegistre = async ( registre : string , id_usuari : number, tipus : number, latitud : number, longitud : number, page: string) => {
    try {
        const response = await fetch(`${apiUrl}:8071/controlhorari/usuaris/${id_usuari}/registres`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'pantalla': page
            },
            body: JSON.stringify({ registre, id_usuari, tipus, longitud, latitud })
        });
        return response.text();

    } catch (error) {
        alert('Error al obtener los datos: '+ error);
    }
};